export default __webpack_public_path__ + "static/media/five.0f74835d.jpg";